export const FPTI_PREFIX = 'main:help:center:'

export const fptiTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
  NO_DATA: 'no-data',
  ON_CLICK: 'on-click',
  VALIDATION_ERROR: 'valdation-error',
  SERVICE_ERROR: 'service-error',
}

// Feature/ component names
export const componentNames = {
  ARTICLE_CONTENT: 'article-content',
  RELATED_ARTICLES: 'related-articles',
  TOPIC_TREE: 'topic-tree',
  HERO_MODULE: 'hero-module',
  SEARCH_BAR: 'search-bar',
  SEARCH_AUTO_SUGGESTIONS: 'search-auto-suggestions',
  BREADCRUMB: 'breadcrumb',
  MORE_WAYS_OF_HELP: 'more-ways-of-help',
  ARTICLE_FEEDBACK: 'article-feedback',
  COMMUNITY_POSTS: 'community-posts',
  TAB_SWITCHER: 'tab-switcher',
  LOGIN_PROMPT: 'login-prompt',
  QUALTRICS_SURVEY: 'qualtrics-survey',
}
